export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'monitor_manage',
  'contact_manage',
  'agenda_manage',
  'product_orders_manage',
  'agent_manage',
  'team_manage',
  'inbox_manage',
  'assignment_policy_manage',
  'automation_manage',
  'label_manage',
  'custom_attribute_manage',
  'integration_manage',
  'campaign_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const MONITOR_PERMISSIONS = 'monitor_manage';

export const AGENDA_PERMISSIONS = 'agenda_manage';

export const PRODUCT_ORDERS_PERMISSIONS = 'product_orders_manage';

export const AGENT_PERMISSIONS = 'agent_manage';

export const TEAM_PERMISSIONS = 'team_manage';

export const INBOX_PERMISSIONS = 'inbox_manage';

export const ASSIGNMENT_POLICY_PERMISSIONS = 'assignment_policy_manage';

export const AUTOMATION_PERMISSIONS = 'automation_manage';

export const LABEL_PERMISSIONS = 'label_manage';

export const CUSTOM_ATTRIBUTE_PERMISSIONS = 'custom_attribute_manage';

export const INTEGRATION_PERMISSIONS = 'integration_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const CUSTOM_ROLE_PERMISSION_GROUPS = [
  {
    key: 'CONVERSATIONS',
    permissions: [
      'conversation_manage',
      'conversation_unassigned_manage',
      'conversation_participating_manage',
      'monitor_manage',
    ],
  },
  {
    key: 'CRM',
    permissions: ['contact_manage', 'agenda_manage', 'product_orders_manage'],
  },
  {
    key: 'WORKSPACE',
    permissions: [
      'agent_manage',
      'team_manage',
      'inbox_manage',
      'assignment_policy_manage',
      'automation_manage',
      'label_manage',
      'custom_attribute_manage',
      'integration_manage',
    ],
  },
  {
    key: 'GROWTH',
    permissions: [
      'campaign_manage',
      'report_manage',
      'knowledge_base_manage',
    ],
  },
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
